import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { GlobalService } from "./global.service";
import { map, catchError } from "rxjs/operators";
import { environment } from "src/environments/environment";

const devUrl = environment.backendurl;

@Injectable({
  providedIn: "root",
})
export class CompanypagesService {
  constructor(private http: HttpClient) {}

  getCompanyList(start, end, paginationoffset,type, companyname, city, industry = '', industryid = '') {
       var url = devUrl + `/companypages/getcompanylist?start=${start}&end=${end}&paginationoffset=${paginationoffset}&type=${type}&companyname=${companyname}&city=${city}&industryid=${industryid}`;
      return this.http.get(url).pipe(
        map((response) => {
          return response;
        }),
        catchError(GlobalService.handleError("get Company List", url))
      );
  }

  getIndustryList(start, end, paginationoffset,type){
    var url = devUrl + `/companypages/getcompanylist?start=${start}&end=${end}&paginationoffset=${paginationoffset}&type=${type}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get Company List", url))
    );
  }

  getCompanyInfo(companyid) {
    var url = devUrl + `/companypages/getcompanyinfo/${companyid}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get Company Info", url))
    );
  }

  getCompanyEmpList(companyid, start, end, city,country,jobtitle, gettopjobtitles) {

    var url =
      devUrl +
      `/companypages/unlockedempdetails/${companyid}?start=${start}&end=${end}&workcity=${city}&workcountry=${country}&jobtitle=${jobtitle}&gettopjobtitles=${gettopjobtitles}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get Company Employee list", url))
    );
  }

  getCompanyExpAndSal(companyid, start, end, location, currency, jobtitle, lockInfo, paginationoffset) {
    var url =
      devUrl +
      `/companypages/getcompanyinfo/${companyid}/expandsalarylist?start=${start}&end=${end}&location=${location}&currency=${currency}&jobtitle=${jobtitle}&lockInfo=${lockInfo}&paginationoffset=${paginationoffset}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(
        GlobalService.handleError("get Company Experience and Salary list", url)
      )
    );
  }

  getUnmaskedCandidate(companyid, candidateid) {
    var url = devUrl + `/companypages/getunmaskedcandidateinfo/?companyid=${companyid}&candidateid=${candidateid}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("get Company List", url))
    );
  }

  companyDirectorySearch(name) {
    var url = devUrl + `/companypages/companydirectorysearch/?name=${name}`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("Company Directory Search", url))
    );
  }

  getUserLocation(body) {
    var url = devUrl + `/companypages/getuserlocation`;
    return this.http.post(url,body).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("Get User Location", url))
    );
  }

  getEnrichedData(body) {
    var url = devUrl + `/companypages/enrichdetails`;
    return this.http.post(url,body).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("Get Enriched Data", url))
    );
  }

  getUnlockedEmpList(companyid, userid){
    var url = devUrl + `/companypages/unlockedempdetails/${companyid}?userid=${userid}&start=0&end=40&workcity&workcountry&jobtitle&gettopjobtitles=true`;
    return this.http.get(url).pipe(
      map((response) => {
        return response;
      }),
      catchError(GlobalService.handleError("Unlocked Employee List", url))
    );
  }

  validateData(companyid,jobtitle,location){
    var url =
    devUrl +
    `/companypages/validate/?companyid=${companyid}&jobtitle=${jobtitle}&location=${location}`;
  return this.http.get(url).pipe(
    map((response) => {
      return response;
    }),
    catchError(
      GlobalService.handleError("validate", url)
    )
  );
  }
  
  removeHyphen(val:any){
    let index;
    if(val.includes('-')){
      index = val.indexOf('-');
      val = val.substring(0,index) + ' ' + val.substring(index+1);
    }
    return val;
  }

  numberWithCommas(x: any) {
    if(x){
      return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return;
  }
}
